import React from 'react'
import styled from './styled.module.scss'
import ReactYoutube from '../../../Tasks/components/YouTube/YouTube';
import {useTranslation} from "react-i18next";

const interview = [
    {author: 'Alexander Nabzdorov', link: 'https://www.youtube.com/watch?v=VveEdPsz4H8'},
    {author: 'Victor Kachin', link: 'https://www.youtube.com/watch?v=otU9ALN8AAo'}
]

const VideosMainPage = () => {
    const { t } = useTranslation();

    return <div className={styled.wrapper}>
        <div className={styled.interview}>
            <h2>{t('interview.title')}</h2>
            <div className={"desc"}>
                <p>
                    {t('interview.desc1')}
                </p>
                <br/>
                <p>
                    {t('interview.desc2')}
                </p>
                <br/>
                <p>
                    {t('interview.desc3')}
                </p>
                <br/>
                <p>
                    {t('interview.desc4')}
                </p>
                <br/>
                <p>
                    {t('interview.desc5')}
                </p>
                <br/>
                <p>
                    {t('interview.desc6')}
                </p>
                <br/>
            </div>
            <div className={styled.content}>
                {interview.map(({link}) => <div className={styled.youtube} key={link}>
                    <ReactYoutube link={link}/>
                </div>)}
            </div>
        </div>
        {/*<div className={styled.lessons}>*/}
        {/*    <h2>Изучайте программирование в любое время и в любом месте</h2>*/}
        {/*    <div className={styled.videos}>*/}
        {/*        {videosArray.map(({title, link}) => <VideoItem key={title} title={title} link={link}/>)}*/}
        {/*    </div>*/}
        {/*</div>*/}
        {/*<button onClick={() => history.push('/webinars')}>Перейти к видео</button>*/}
    </div>
}

export default VideosMainPage;
